const validateError = (error) => error.error && typeof error?.error?.code === 'number';
const parseError = (error) => error.error;
const generateUnhandledError = ({ error, defaultMessage = 'Unhandled Error' }) => error.textCode || defaultMessage;
export default ({ error, errors, unhandledErrorMessage }) => {
  if (validateError(error)) {
    const { code } = parseError(error);
    return errors[code] || generateUnhandledError({ defaultMessage: unhandledErrorMessage, error });
  } else {
    return generateUnhandledError({ defaultMessage: unhandledErrorMessage, error });
  }
};
